import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Col, Row, UiBox, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {WEIGHT_LOSS_KEYS} from '~/constants/medical-questionnaires';
import {setNextQuestionnaire} from '~/redux/questionnaires/slice';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {spacing} from '~/utils/theme/spacing';

const Questionnaire6Screen = () => {
  const dispatch: AppDispatch = useDispatch();
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(i => i.key === WEIGHT_LOSS_KEYS.HOW_WEIGHT_LOSS_PROGRAM_WORKS);

  const onClickSubmit = () => {
    dispatch(setNextQuestionnaire({value: WEIGHT_LOSS_KEYS.BMI_CALCULATOR}));
  };

  const renderSteps = (step: {key: string; title: string; description: string}, isActiveStage: boolean) => {
    const isActiveStep = isActiveStage && step.key === 'STEP_1';
    return (
      <Row mt={2} key={step?.key}>
        <UiBox
          style={{
            width: '1px',
            height: '100%',
            borderLeft: '1px dashed #2C414233',
            position: 'relative',
          }}
        >
          <UiBox
            style={{
              width: `${isActiveStep ? '16px' : '8px'}`,
              height: `${isActiveStep ? '16px' : '8px'}`,
              backgroundColor: `${isActiveStep ? '#457672' : '#2C414233'}`,
              borderRadius: '50%',
              position: 'absolute',
              left: 0,
              top: 10,
              transform: 'translateX(-55%)',
            }}
          />
        </UiBox>
        <Col align="flex-start" w="100%" ml={5} textAlign="left" mb={2}>
          <UiText fontSize={14} fontWeight={600} w="100%">
            {step.title}
          </UiText>
          <UiText fontSize={12} fontWeight={500} opacity={0.6} w="100%">
            {step.description}
          </UiText>
        </Col>
      </Row>
    );
  };

  const renderStage = (stage: {
    key: string;
    title: string;
    description: string;
    steps: {
      key: string;
      title: string;
      description: string;
    }[];
  }) => {
    const isActiveStage = stage?.key === 'STAGE_1';
    return (
      <Col key={stage?.key} align="flex-start" w="100%" textAlign="left" mb={4}>
        <UiText fontSize={16} fontWeight={600} mb={1}>
          {stage?.title}
        </UiText>
        <UiText fontSize={12} fontWeight={500} opacity={0.6}>
          {stage?.description}
        </UiText>
        {stage?.steps?.map(step => renderSteps(step, isActiveStage))}
      </Col>
    );
  };
  return (
    <UiQuestionnaireLayout
      backIcon
      handleOnNext={onClickSubmit}
      actions={questionnaire?.actions}
      checkoutStep={questionnaire?.checkoutStep}
    >
      <Col align="center" textAlign="center">
        <UiText variant="mdqTitle" mt={10}>
          {questionnaire?.questions?.default}
        </UiText>
        <Col mt={10} px={spacing.tiny}>
          {questionnaire?.stages?.map(stage => renderStage(stage))}
        </Col>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire6Screen;
